import L from 'leaflet';
import 'proj4';
import 'proj4leaflet';

import type { MapSetupOptions } from './Map.types';

// Resolutions array have one additional entry because of this: https://github.com/kartena/Proj4Leaflet/issues/144
// That's also why maxZoom below uses length-2
export const mapOptions: L.MapOptions = {
    crs: new L.Proj.CRS('EPSG:3006', '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs', {
        resolutions: [
            4096.000031, 2056.995716, 1023.999942, 511.9999708, 255.9999854, 128.000125, 64.00006249, 32.00003124, 15.99988333, 7.999941665,
            3.999970833, 1.999985416, 1.000125, 0.5000625, 0.25003125,
        ],
        origin: [-682109.3293283656, 8378211.317528921],
    }),
    minZoom: 2,
    maxZoom: 13,
    zoomControl: false,
    closePopupOnClick: true,
};

export class MapSetup extends L.Map {
    _baseMap: L.TileLayer;
    constructor(element: L.Content, options?: MapSetupOptions) {
        super(element, {
            ...mapOptions,
            ...options,
        });

        this.attributionControl.setPrefix('');

        // Hack to make MarkerCluster animated spiderfy work as expected
        L.Path['SVG'] = true;

        this._baseMap = L.tileLayer(
            options.mapServerUrl +
                'wmts.axd/bkgnd_map_view?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&STYLE=&LAYER=bkgnd' +
                '&TILEMATRIXSET=Default.256.3006&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=image%2Fpng%3B%20mode=8bit' +
                `&v=${options.mapTilesVersion}`,
            {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>',
                tileSize: 256,
                tms: true,
                noWrap: true,
            },
        ).addTo(this);
    }
}
